/* Routing helpers — enforce the 3 portal architecture. */
export function landingRouteFor(user, isAdmin) {
  if (!user) return '/';
  if (user.is_bootstrap_admin) return '/bootstrap/dashboard';
  if (isAdmin) return '/admin/dashboard';
  return '/dashboard';
}

// Real "shows the Admin portal" check. Intentionally strict — the backend
// still enforces per-endpoint permission checks, so this is only about UI.
// A user is considered admin-visible when they have `is_bootstrap_admin`,
// the legacy `is_admin` flag, OR one of the actual write-scoped admin
// permissions (users.view / roles.view / analytics.view / *).
// Moderators, Support, Developer roles do NOT flip this flag by default —
// they get scoped tools inside their own experience instead.
const ADMIN_PORTAL_PERMS = new Set([
  '*',
  'admins.manage',
  'users.view', 'users.suspend', 'users.grant_premium', 'users.reset_password', 'users.assign_badge',
  'roles.manage', 'roles.view',
  'system.settings',
  'analytics.view',
  'auditlog.view',
  'battle.balance.manage',
]);

export function isAdminUser(user) {
  if (!user) return false;
  if (user.is_bootstrap_admin) return true;
  if (user.is_admin) return true;
  const perms = Array.isArray(user.permissions) ? user.permissions : [];
  for (const p of perms) {
    if (ADMIN_PORTAL_PERMS.has(p)) return true;
  }
  return false;
}
